export enum TipoSenhaMaster {
    Sync = 1, 
    SyncDev = 2, 
}

const getVariaveisPadraoSenha = (): { [key: string]: string } => {
    const now = new Date();
    return {
        "[dd]": now.getDate().toString(), 
        "[MM]": (now.getMonth() + 1).toString(), 
        "[HH]": now.getHours().toString(),
    };
};

/**
 * @param expressao 
 * @returns
 * @description
 */
const calcularExpressao = (expressao: string): string => {
    const expressaoLimpa = expressao.trim();
    if (!expressaoLimpa) return '0';

    try {
        // eslint-disable-next-line no-new-func
        const fn = new Function(`return ${expressaoLimpa}`);
        const resultado = fn();

        if (typeof resultado === 'number' && !isNaN(resultado)) {
            return String(resultado);
        }

        console.error("Resultado da expressão não é um número válido:", expressao, resultado);
        return '0';
    } catch (ex) {
        console.error("Erro ao calcular expressão no serviço de segurança:", expressao, ex);
        return '0'; 
    }
};

/**
 * @param xPadraoSenha 
 * @returns 
 */
const resolverPadraoSenha = (xPadraoSenha: string): string => {
    let xSenha = xPadraoSenha;
    const variaveis = getVariaveisPadraoSenha();

    for (const tag in variaveis) {
        const regex = new RegExp(tag.replace(/[[\]]/g, '\\$&'), 'g');
        xSenha = xSenha.replace(regex, variaveis[tag]);
    }

    xSenha = xSenha.replace(/\[|\]/g, "");

    const pattern = /\(([^)]+)\)/g;

    xSenha = xSenha.replace(pattern, (match, expressaoEntreParenteses) => {
        return calcularExpressao(expressaoEntreParenteses);
    });

    return xSenha.trim();
};

/**
 * @param login
 * @param padraoFornecido
 * @param tipoSenha
 * @returns
 */

export const gerarSenhaTecnicaSync = (login: string, padraoFornecido?: string, tipoSenha: TipoSenhaMaster = TipoSenhaMaster.Sync): string => {
    try {
        let padraoSenha: string;

        if (padraoFornecido) {
            padraoSenha = padraoFornecido;
        } else {
            switch (tipoSenha) {
                case TipoSenhaMaster.Sync:
                    padraoSenha = "@([dd] + [MM])([HH] + 10)"; 
                    break;
                case TipoSenhaMaster.SyncDev:
                    padraoSenha = "@([HH] + 20)([dd] + [MM] + 05)"; 
                    break;
                default:
                    throw new Error("Tipo de senha não configurado.");
            }
        }

        return resolverPadraoSenha(padraoSenha);

    } catch (error) {
        console.error("Falha fatal na geração da Senha Técnica:", error);
        return 'ERRO_SENHA_TEC'; 
    }
};